"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _lodash = _interopRequireDefault(require("lodash"));

var _ampApi = require("@amplify/amp-api");

var _realtimeService = _interopRequireDefault(require("./realtimeService"));

var _storageService = _interopRequireDefault(require("./storageService"));

var _constants = require("../shared/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var applyRecordExpiration = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(record) {
    var timeMs, ttl;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(record.updatedOn && _lodash.default.isNumber(record.updatedOn))) {
              _context.next = 7;
              break;
            }

            _context.next = 3;
            return _realtimeService.default.getTimeMs();

          case 3:
            timeMs = _context.sent;
            ttl = _constants.MAX_CLASSROOM_RECORD_AGE - timeMs + record.updatedOn;
            record.isExpired = ttl <= 0;
            record.ttl = Math.max(0, ttl);

          case 7:
            return _context.abrupt("return", record);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function applyRecordExpiration(_x) {
    return _ref.apply(this, arguments);
  };
}();

var ClassroomOrchestrationService = /*#__PURE__*/function () {
  // keep track of a structure to allow us to force resyncs at any time
  function ClassroomOrchestrationService() {
    (0, _classCallCheck2.default)(this, ClassroomOrchestrationService);
    (0, _defineProperty2.default)(this, "userId", void 0);
    (0, _defineProperty2.default)(this, "classReSyncs", []);
    this.publishClassPacing = _lodash.default.debounce(this.publishClassPacing.bind(this), 500);
  }

  (0, _createClass2.default)(ClassroomOrchestrationService, [{
    key: "init",
    value: function init(userId) {
      this.userId = userId;
    }
  }, {
    key: "publishClassStatus",
    value: function publishClassStatus(classKey, isStarted, tabId, classSessionId, recipient, sendDirectly) {
      return this.publishClassRecord(classKey, _constants.CLASS_RECORD_TYPES.CLASS_STATUS, {
        classKey: classKey,
        status: isStarted ? _constants.CLASS_STATUSES.STARTED : _constants.CLASS_STATUSES.NOT_STARTED,
        activeTeacherKey: this.userId,
        managingTabId: tabId,
        classSessionId: classSessionId
      }, recipient, sendDirectly);
    }
  }, {
    key: "publishClassEyesUpStatus",
    value: function publishClassEyesUpStatus(classKey, isEyesUpActive, recipient) {
      return this.publishClassRecord(classKey, _constants.CLASS_RECORD_TYPES.EYES_UP, {
        classKey: classKey,
        eyesUpStatus: isEyesUpActive ? _constants.EYES_UP_STATUSES.ACTIVE : _constants.EYES_UP_STATUSES.INACTIVE,
        activeTeacherKey: this.userId
      }, recipient);
    }
  }, {
    key: "publishClassContentLocation",
    value: function publishClassContentLocation(classKey, contentBreadcrumb, recipient) {
      return this.publishClassRecord(classKey, _constants.CLASS_RECORD_TYPES.CLASS_LOCATION, {
        classKey: classKey,
        contentBreadcrumb: contentBreadcrumb,
        activeTeacherKey: this.userId
      }, recipient);
    }
  }, {
    key: "publishClassPacing",
    value: function publishClassPacing(classKey, classPacing, recipient) {
      return this.publishClassRecord(classKey, _constants.CLASS_RECORD_TYPES.CLASS_PACING, {
        classKey: classKey,
        classPacing: classPacing,
        activeTeacherKey: this.userId
      }, recipient);
    }
  }, {
    key: "publishStudentLocation",
    value: function publishStudentLocation(classKey, contentBreadcrumb, status, recipient) {
      if (status && !Object.values(_constants.STUDENT_LOCATION_STATUSES).includes(status)) {
        throw new Error("Invalid status \"".concat(status, "\" supplied for ").concat(_constants.STUDENT_RECORD_TYPES.STUDENT_LOCATION, " record"));
      }

      return this.publishStudentRecord(this.userId, classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_LOCATION, {
        studentId: this.userId,
        classKey: classKey,
        contentBreadcrumb: contentBreadcrumb,
        studentStatus: status
      }, recipient);
    }
  }, {
    key: "publishStudentHandRaiseState",
    value: function publishStudentHandRaiseState(classKey, studentId, raised, classSessionId, recipient) {
      return this.publishStudentRecord(studentId, classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_HAND_RAISE_CHANGE, {
        studentId: studentId,
        raised: raised,
        classSessionId: classSessionId
      }, recipient);
    }
  }, {
    key: "publishClassRecord",
    value: function () {
      var _publishClassRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(classKey, recordType, record, recipient) {
        var sendDirectly,
            timeMs,
            recordJson,
            payload,
            _args2 = arguments;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                sendDirectly = _args2.length > 4 && _args2[4] !== undefined ? _args2[4] : false;
                _context2.next = 3;
                return _realtimeService.default.getTimeMs();

              case 3:
                timeMs = _context2.sent;
                recordJson = _objectSpread(_objectSpread({}, record), {}, {
                  updatedOn: timeMs
                });
                _context2.next = 7;
                return _storageService.default.saveClassroomState(classKey, recordType, recordJson);

              case 7:
                payload = {
                  classKey: classKey
                };

                if (sendDirectly) {
                  payload.directPayload = recordJson;
                }

                return _context2.abrupt("return", _realtimeService.default.publish(classKey, recordType, payload, recipient));

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function publishClassRecord(_x2, _x3, _x4, _x5) {
        return _publishClassRecord.apply(this, arguments);
      }

      return publishClassRecord;
    }()
  }, {
    key: "publishStudentRecord",
    value: function () {
      var _publishStudentRecord = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(studentId, classKey, recordType, record, recipient) {
        var timeMs, recordJson;
        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _realtimeService.default.getTimeMs();

              case 2:
                timeMs = _context3.sent;
                recordJson = _objectSpread(_objectSpread({}, record), {}, {
                  updatedOn: timeMs
                });
                _context3.next = 6;
                return _storageService.default.saveUserFile(studentId, "".concat(recordType, "-").concat(classKey), recordJson);

              case 6:
                return _context3.abrupt("return", _realtimeService.default.publish(classKey, recordType, {
                  studentId: studentId,
                  classKey: classKey
                }, recipient));

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function publishStudentRecord(_x6, _x7, _x8, _x9, _x10) {
        return _publishStudentRecord.apply(this, arguments);
      }

      return publishStudentRecord;
    }()
  }, {
    key: "addListenerForClassStatus",
    value: function addListenerForClassStatus(classKeys, callback) {
      this.addListenerForClassRecord(classKeys, _constants.CLASS_RECORD_TYPES.CLASS_STATUS, callback);
    }
  }, {
    key: "addListenerForEyesUpStatus",
    value: function addListenerForEyesUpStatus(classKeys, callback) {
      this.addListenerForClassRecord(classKeys, _constants.CLASS_RECORD_TYPES.EYES_UP, callback);
    }
  }, {
    key: "addListenerForClassContentLocation",
    value: function addListenerForClassContentLocation(classKeys, callback) {
      this.addListenerForClassRecord(classKeys, _constants.CLASS_RECORD_TYPES.CLASS_LOCATION, callback);
    }
  }, {
    key: "addListenerForStudentLocations",
    value: function addListenerForStudentLocations(classKey, studentIds, callback) {
      this.addListenerForStudentRecord(classKey, studentIds, _constants.STUDENT_RECORD_TYPES.STUDENT_LOCATION, callback);
    }
  }, {
    key: "addListenerForStudentHandRaiseState",
    value: function addListenerForStudentHandRaiseState(classKey, studentIds, callback) {
      this.addListenerForStudentRecord(classKey, studentIds, _constants.STUDENT_RECORD_TYPES.STUDENT_HAND_RAISE_CHANGE, callback);
    }
  }, {
    key: "addListenerForClassPacing",
    value: function addListenerForClassPacing(classKeys, callback) {
      this.addListenerForClassRecord(classKeys, _constants.CLASS_RECORD_TYPES.CLASS_PACING, callback);
    }
  }, {
    key: "addListenerForClassRecord",
    value: function addListenerForClassRecord(classKeys, recordType, callback) {
      var _this = this;

      var notificationCallback = /*#__PURE__*/function () {
        var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee5(channels, payload, publisher) {
          var hasDirectPayload, record, body, classroomStateStringified;
          return _regenerator.default.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  // if there is a directPayload then we send that directly - otherwise fetch from source of truth
                  // this allows us to prevent some duplicate fetches e.g. for a class status heartbeat notification
                  hasDirectPayload = payload.directPayload !== undefined;

                  if (Array.isArray(channels)) {
                    _context5.next = 15;
                    break;
                  }

                  if (classKeys.includes(channels)) {
                    _context5.next = 4;
                    break;
                  }

                  return _context5.abrupt("return");

                case 4:
                  _context5.t0 = payload.directPayload;

                  if (_context5.t0) {
                    _context5.next = 9;
                    break;
                  }

                  _context5.next = 8;
                  return (0, _ampApi.fetchClassroomState)(payload.classKey, recordType);

                case 8:
                  _context5.t0 = _context5.sent;

                case 9:
                  record = _context5.t0;
                  _context5.next = 12;
                  return applyRecordExpiration(record);

                case 12:
                  callback(channels, _objectSpread(_objectSpread({}, record), {}, {
                    classKey: payload.classKey
                  }), publisher, hasDirectPayload);
                  _context5.next = 21;
                  break;

                case 15:
                  body = channels.map(function (channel) {
                    return ["".concat(channel), "".concat(recordType)];
                  });
                  _context5.next = 18;
                  return (0, _ampApi.batchFetchClassroomState)(body, true);

                case 18:
                  classroomStateStringified = _context5.sent;
                  _context5.next = 21;
                  return Promise.all(Object.values(classroomStateStringified).map( /*#__PURE__*/function () {
                    var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee4(recordStringified) {
                      return _regenerator.default.wrap(function _callee4$(_context4) {
                        while (1) {
                          switch (_context4.prev = _context4.next) {
                            case 0:
                              _context4.next = 2;
                              return applyRecordExpiration(JSON.parse(recordStringified));

                            case 2:
                              record = _context4.sent;
                              callback(record.classKey, _objectSpread(_objectSpread({}, record), {}, {
                                classKey: record.classKey
                              }), publisher, hasDirectPayload);

                            case 4:
                            case "end":
                              return _context4.stop();
                          }
                        }
                      }, _callee4);
                    }));

                    return function (_x14) {
                      return _ref3.apply(this, arguments);
                    };
                  }()));

                case 21:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function notificationCallback(_x11, _x12, _x13) {
          return _ref2.apply(this, arguments);
        };
      }();

      _realtimeService.default.addEventListener(recordType, notificationCallback, callback, classKeys);

      classKeys = Array.isArray(classKeys) ? classKeys : [classKeys]; // notification callback triggered for all classes in order to get full initial state

      notificationCallback(classKeys, {}, this.userId); // track added listeners to allow us to force resync later

      this.classReSyncs.push({
        callback: callback,
        reSyncCallback: function reSyncCallback() {
          return notificationCallback(classKeys, {}, _this.userId);
        }
      });
    }
  }, {
    key: "forceClassRecordReSync",
    value: function forceClassRecordReSync() {
      return Promise.all(this.classReSyncs.map(function (_ref4) {
        var reSyncCallback = _ref4.reSyncCallback;
        return reSyncCallback();
      }));
    }
  }, {
    key: "addListenerForStudentRecord",
    value: function addListenerForStudentRecord(classKey, studentIds, recordType, callback) {
      var notificationCallback = /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee6(channel, payload, publisher) {
          var record;
          return _regenerator.default.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  if (!(channel !== classKey || !studentIds.includes(publisher))) {
                    _context6.next = 2;
                    break;
                  }

                  return _context6.abrupt("return");

                case 2:
                  _context6.next = 4;
                  return (0, _ampApi.fetchUserFile)(payload.studentId, "".concat(recordType, "-").concat(payload.classKey));

                case 4:
                  record = _context6.sent;
                  _context6.next = 7;
                  return applyRecordExpiration(record);

                case 7:
                  callback(channel, _objectSpread(_objectSpread({}, record), {}, {
                    studentId: payload.studentId
                  }), publisher);

                case 8:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function notificationCallback(_x15, _x16, _x17) {
          return _ref5.apply(this, arguments);
        };
      }();

      studentIds = Array.isArray(studentIds) ? studentIds : [studentIds];

      if (studentIds.length === 1 && studentIds[0] === this.userId) {
        notificationCallback(classKey, {
          studentId: studentIds[0],
          classKey: classKey
        }, studentIds[0]);
      } else {
        (0, _ampApi.fetchClientStateBatch)(studentIds, "".concat(recordType, "-").concat(classKey)).then(function (payload) {
          payload === null || payload === void 0 ? void 0 : payload.forEach( /*#__PURE__*/function () {
            var _ref6 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee7(response) {
              var record;
              return _regenerator.default.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      record = response.clientState;
                      _context7.next = 3;
                      return applyRecordExpiration(record);

                    case 3:
                      callback(classKey, _objectSpread(_objectSpread({}, record), {}, {
                        studentId: record.studentId
                      }), record.studentId);

                    case 4:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }));

            return function (_x18) {
              return _ref6.apply(this, arguments);
            };
          }());
        });
      }

      _realtimeService.default.addEventListener(recordType, notificationCallback, callback);
    }
  }, {
    key: "addListenerForStudentVariantChange",
    value: function addListenerForStudentVariantChange(classKeys, studentIds, variantDisplaySchema, callback) {
      if (classKeys.length === 0) {
        return;
      }

      var notificationCallback = /*#__PURE__*/function () {
        var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee8(channel, payload, publisher) {
          var studentIdsForFetch, records;
          return _regenerator.default.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  if (classKeys.includes(channel)) {
                    _context8.next = 2;
                    break;
                  }

                  return _context8.abrupt("return");

                case 2:
                  studentIdsForFetch = payload.filter(function (studentId) {
                    return studentIds.includes(studentId);
                  });

                  if (!(studentIdsForFetch.length > 0)) {
                    _context8.next = 8;
                    break;
                  }

                  _context8.next = 6;
                  return (0, _ampApi.fetchStudentVariantsBatch)(studentIdsForFetch, variantDisplaySchema);

                case 6:
                  records = _context8.sent;
                  callback(channel, records, publisher);

                case 8:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function notificationCallback(_x19, _x20, _x21) {
          return _ref7.apply(this, arguments);
        };
      }();

      _realtimeService.default.addEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_VARIANT_CHANGE, notificationCallback, callback);
    }
  }, {
    key: "publishStudentVariantChange",
    value: function publishStudentVariantChange(classKey, studentIds, recipient) {
      return _realtimeService.default.publish(classKey, _constants.STUDENT_RECORD_TYPES.STUDENT_VARIANT_CHANGE, studentIds, recipient);
    }
  }, {
    key: "removeListenerForClassRecord",
    value: function removeListenerForClassRecord(recordType, callback) {
      this.classReSyncs = this.classReSyncs.filter(function (reSync) {
        return reSync.callback !== callback;
      });

      _realtimeService.default.removeEventListener(recordType, callback);
    }
  }, {
    key: "removeListenerForStudentVariantChange",
    value: function removeListenerForStudentVariantChange(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_VARIANT_CHANGE, callback);
    }
  }, {
    key: "removeListenerForClassStatus",
    value: function removeListenerForClassStatus(callback) {
      this.removeListenerForClassRecord(_constants.CLASS_RECORD_TYPES.CLASS_STATUS, callback);
    }
  }, {
    key: "removeListenerForEyesUpStatus",
    value: function removeListenerForEyesUpStatus(callback) {
      this.removeListenerForClassRecord(_constants.CLASS_RECORD_TYPES.EYES_UP, callback);
    }
  }, {
    key: "removeListenerForClassContentLocation",
    value: function removeListenerForClassContentLocation(callback) {
      this.removeListenerForClassRecord(_constants.CLASS_RECORD_TYPES.CLASS_LOCATION, callback);
    }
  }, {
    key: "removeListenerForStudentLocations",
    value: function removeListenerForStudentLocations(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_LOCATION, callback);
    }
  }, {
    key: "removeListenerForStudentHandRaiseState",
    value: function removeListenerForStudentHandRaiseState(callback) {
      _realtimeService.default.removeEventListener(_constants.STUDENT_RECORD_TYPES.STUDENT_HAND_RAISE_CHANGE, callback);
    }
  }, {
    key: "removeListenerForClassPacing",
    value: function removeListenerForClassPacing(callback) {
      this.removeListenerForClassRecord(_constants.CLASS_RECORD_TYPES.CLASS_PACING, callback);
    }
  }]);
  return ClassroomOrchestrationService;
}();

var _default = new ClassroomOrchestrationService();

exports.default = _default;
//# sourceMappingURL=classroomOrchestrationService.js.map